<router-outlet></router-outlet>
<app-loading-overlay
  [show]="(loading.show$ | async) ?? false"
  [text]="(loading.text$ | async) ?? 'Cargando...'"
></app-loading-overlay>
